import React from 'react';

import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import type { Coordinates } from 'src/components/YandexMap/types';
import { Hotel as HotelIcon } from '@lt/components/icons-react/rebrand';

import styles from './marker.module.css';

const YMapMarker = loadReactComponent('YMapMarker', loadModulePromise);

type MarkerProps = {
  coordinates: Coordinates;
};

export const Marker = (props: MarkerProps) => {
  const { coordinates } = props;

  return (
    <YMapMarker coordinates={coordinates}>
      <div className={styles.container}>
        <HotelIcon className={styles.icon} />
      </div>
    </YMapMarker>
  );
};
